import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter, Inject,
  Input, OnChanges,
  OnInit, Output, SimpleChanges
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {VisitPlanJobModel} from "../../../models/visit-plan-job.model";
import {VisitPlanScheduleFacadeService} from "../../services/visit-plan-schedule-facade.service";
import {VisitPlanHttpService} from "../../services/visit-plan-http.service";
import * as _ from "lodash";
import {EntityStoreService} from "../../../../commons/angular/services/entity-store.service";
import {unset} from "lodash";
import {VisitPlanRouteModel} from "../../../models/visit-plan-route.model";
import {VisitPlanCellModel} from "../../../models/visit-plan-cell.model";
import {VisitScheduleDayModel} from "../../../models/visit-schedule-day.model";
import {isVisitPlanRouteBlocked} from "../../../models/visit-plan-route.functions";
import {
  VisitPlanScheduleResourceSelectListComponent
} from "../visit-plan-schedule-resource-select-list/visit-plan-schedule-resource-select-list.component";

require('./visit-plan-routes-panel.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-routes-panel',
  templateUrl: './visit-plan-routes-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanRoutesPanelComponent implements OnInit, OnChanges {

  @Input() visitPlan: VisitPlanModel;
  @Input() visitPlanRange?: { dateStart, dateEnd };
  @Input() panel: any;
  @Input() panels: any[];
  @Input() routes: VisitPlanRouteModel[];
  @Input() isLoadingRoutes: boolean;
  @Input() selectedRouteId: string;
  @Input() jobs: any[];
  @Input() agentColorMap: { [key: string]: string };
  // @Input() routes: any[];
  @Input() selectedIds: string[];
  @Input() selectedJobIds: string[];
  @Input() visitScheduleDays: VisitScheduleDayModel[];
  @Input() programTypeAliasMap: { [key: string]: string };
  // @Output() onCreateRoute = new EventEmitter<{ jobIds: string[], resourceId: string }>();
  @Output() onCreateRoute = new EventEmitter<{ jobIds: string[], resourceId: string }>();
  @Output() onMoveJobs = new EventEmitter();
  @Output() onSelectedRoutesChange = new EventEmitter<string[]>();
  @Output() onSelectedJobsChange = new EventEmitter<string[]>();
  @Output() onDeleteRoutes = new EventEmitter<string[]>();
  @Output() onReoptimizeRoutes = new EventEmitter<string[]>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onRoutePanelContextMenu = new EventEmitter<{routeId: string, event: any}>
  @Output() onPanelChange = new EventEmitter<any>();
  @Output() onClose = new EventEmitter();
  @Output() onEditCallServiceTime = new EventEmitter<{ callId: string, slot: VisitPlanCellModel, isDayDispatched: boolean, event: MouseEvent }>();
  @Output() onAssign = new EventEmitter<{ event: Event, jobIds: string[], visitPlan: VisitPlanModel, dateRange?: { from: number, to: number }}>();

  public displayedRoutes: any[] = [];
  public selectedRoute?: VisitPlanRouteModel;
  public queryString: string;
  public cursor: string;
  public limit: number = 20;
  public isLoading: boolean = false;
  public filters: any = {
    branchIds: [],
    agentIds: [],
    day: undefined
  };
  public dayOptions: number[];
  public isSelectedRouteDayDispatched: boolean;

  constructor(@Inject(PanelService) private panelService: PanelService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(VisitPlanScheduleFacadeService) private visitPlanScheduleFacadeService: VisitPlanScheduleFacadeService,
              @Inject(VisitPlanHttpService) private visitPlanHttpService: VisitPlanHttpService,
              @Inject(EntityStoreService) private entityStoreService: EntityStoreService<any>,
              @Inject('splitService') private splitService,
              @Inject('schedulingProjectAlertsService') private schedulingProjectAlertsService) {
  }

  ngOnInit() {
    this._setDaySelection();
    this._setDisplayedRoutes();

    if (this.selectedRouteId) {
      const selectedRoute = this.routes?.find((r) => {return r.id === this.selectedRouteId});
      if (!!selectedRoute) {
        this.selectedRoute = selectedRoute;
      }
    }

    this._setIsSelectedRouteDayDispatched();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.visitPlanRange && !changes.visitPlanRange.isFirstChange())
    ) {
      this._setDaySelection();
      this._setDisplayedRoutes();
    }
    if (changes.selectedRouteId && !changes.selectedRouteId.isFirstChange()) {
      const selectedRoute = this.routes?.find((r) => {return r.id === this.selectedRouteId});
      if (!!selectedRoute) {
        this.selectedRoute = selectedRoute;
      }
    }
    if (changes.routes && !changes.routes.isFirstChange()) {
      if (this.selectedRoute) {
        const selectedRoute = this.routes?.find((r) => {return r.id === this.selectedRoute.id});
        if (!!selectedRoute) {
          this.selectedRoute = selectedRoute;
        }
      }
      this._setDisplayedRoutes();
    }

    this._setIsSelectedRouteDayDispatched();
  }

  onAgentsSelect(agentIds) {
    this.filters.agentIds = agentIds;

    this._setDisplayedRoutes();
    this.onSelectedRoutesChange.emit([]);
  }

  onDayFilterSelect(day?: number) {
    this.filters.day = day;

    this._setDisplayedRoutes();
    this.onSelectedRoutesChange.emit([]);
  }

  // getNextBatch() {
  //   if (!!this.cursor && !this.isLoading) {
  //     this._getRoutes(true);
  //   }
  // }

  onRouteSelect(selectedRoute) {
    this.selectedRoute = selectedRoute;
    this.panel.selectedRouteId = selectedRoute?.id;
    this._setIsSelectedRouteDayDispatched();
    this.onPanelChange.emit(this.panel);
  }

  get blockedActionTooltipKey(): string {
    return this.isSelectedRouteDayDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.ACTION_BLOCKED_CALL_DISPATCHED' : '';
  }

  private _setIsSelectedRouteDayDispatched() {
    this.isSelectedRouteDayDispatched = isVisitPlanRouteBlocked(this.selectedRoute, this.visitScheduleDays);
  }

  onSelectJobs(selectedJobIds: string[]) {
    this.selectedJobIds = selectedJobIds;
    this.onSelectedJobsChange.emit(selectedJobIds);
  }

  onQueryChange(query) {
    this.queryString = query;
    this._setDisplayedRoutes();
  }

  // private _getRoutes(isNext?: boolean) {
  //   this.isLoading = true;
  //
  //   if (!isNext) {
  //     this.routes = [];
  //     this.cursor = undefined;
  //   }
  //   this.visitPlanHttpService.getVisitScheduleRoutesCursor(this.visitPlan.id, this.visitPlan.scheduleId, this._getQueryParams())
  //     .subscribe({
  //       next: res => {
  //         if (!isNext) {
  //           this.routes = [];
  //           this.cursor = undefined;
  //         }
  //         this.cursor = res.cursor;
  //         this.routes = [...this.routes, ...res.list];
  //         this.isLoading = false;
  //         this.entityStoreService.setEntities(this.routes);
  //         this.cdr.detectChanges();
  //       },
  //       error: () => {
  //         this.isLoading = false;
  //       },
  //       complete: () => {
  //         this.isLoading = false;
  //       }
  //     });
  // }

  private _getQueryParams() {
    const params = {
      limit: this.limit,
      from: this.visitPlanRange?.dateStart,
      to: this.visitPlanRange?.dateEnd,
      cursor: this.cursor,
      agentIds: this.filters.agentIds,
      query: this.queryString,
    }
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  private _setDaySelection() {
    this.dayOptions = this._getDailyTimestampsInRange(this.visitPlanRange.dateStart, this.visitPlanRange.dateEnd);
  }

  private _getDailyTimestampsInRange(from: number, to: number): number[] {
    const result: number[] = [];

    const current = new Date(from);
    const end = new Date(to);

    // Normalize to start of day
    current.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    while (current <= end) {
      result.push(current.getTime());
      current.setDate(current.getDate() + 1);
    }

    return result;
  }

  private _setDisplayedRoutes() {
    this.displayedRoutes = (this.routes || [])?.filter((r) => {
      return this._filterRouteByFilters(r);
    })
    this.cdr.detectChanges();
  }

  private _filterRouteByFilters(route) {

    // Filter by Agents
    if (this.filters.agentIds?.length) {
      const agentId = _.get(route, 'resource.agentId');
      if (!_.includes(this.filters.agentIds, agentId)) {
        return false;
      }
    }

    // Filter by Day
    if (!!this.filters.day) {
      const routeFrom: any = route.activities[0].eta;
      const routeTo: any = route.activities[route.activities.length - 1].etd;
      const isInRange = this._isDateInRange(this.filters.day, routeFrom, routeTo);
      if (!isInRange) {
        return false;
      }
    }

    // Filter by Query
    if (!!this.queryString) {
      if (!_.includes(JSON.stringify(route), this.queryString)) {
        return false;
      }
    }

    return true;
  }

  private _isDateInRange(targetTs: number, startTs: number, endTs: number): boolean {
    const normalize = (ts: number) => {
      const d = new Date(ts);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate()
      ).getTime();
    };

    const target = normalize(targetTs);
    const start = normalize(startTs);
    const end = normalize(endTs);

    return target >= start && target <= end;
  }
}
